import { render, staticRenderFns } from "./DesktopFullWidth.vue?vue&type=template&id=24c4ef6d&scoped=true&"
import script from "./DesktopFullWidth.vue?vue&type=script&lang=ts&"
export * from "./DesktopFullWidth.vue?vue&type=script&lang=ts&"
import style0 from "./DesktopFullWidth.vue?vue&type=style&index=0&id=24c4ef6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c4ef6d",
  null
  
)

export default component.exports